import { Routes } from '@angular/router';
import { appRoutes } from './constants/app-routes';

export const routes: Routes = [
  {
    path: appRoutes.survey.base,
    loadComponent: () =>
      import('./components/survey/survey.component').then(
        (c) => c.SurveyComponent
      ),
  },
  {
    path: `${appRoutes.survey.base}/${appRoutes.survey.thankyou}`,
    loadComponent: () =>
      import('./components/survey/thankyou/thankyou.component').then(
        (c) => c.ThankyouComponent
      ),
  },
  {
    path: appRoutes.institutional.base,
    loadComponent: () =>
      import('./modules/institutional/institutional.component').then(
        (c) => c.InstitutionalComponent
      ),
  },
  {
    path: appRoutes.insured.base,
    loadComponent: () =>
      import('./modules/insured/insured.component').then(
        (c) => c.InsuredComponent
      ),
  },
  {
    path: '',
    redirectTo: appRoutes.insured.base,
    pathMatch: 'full',
  },
];
